export default {
  name: "Add Ad Hoc Document(s)",
  pageInfo: {
    text: "Use this form to upload an additional document to your submitted application. Uploaded documents will be added to the case documents and directed to an analyst for review. Please do NOT use this form to upload a response to a Notice of Deficiency (NOD) or to upload a Recruitment Report.",
    coloring: "grey",
  },
  sections: [
    {
      fields: [
        {
          machine_name: "files",
          widget: "file_upload",
          file_upload: { fileType: "Ad_Hoc_Document_Upload" },
          accept_multiple: false,
          required: true,
          validate: ["required", "file_required"],
          checkFilesAdded: true,
          documentAuth: "dh",
        },
        {
          machine_name: "fileType",
          widget: "select",
          label: "Document Category",
          selection: [
            "Documentation of Fixed-Site Agricultural Business",
            "Fixed Site Agricultural Business Fully-Executed Work Contract",
            "Attorney G-28 or Agent Documentation",
            "Employer-Provided or Range Housing Documentation",
            "Workers' Compensation Insurance or Other Coverage Documentation",
            "Rental or Public Accommodation Housing Documentation",
            "NOD Response",
            "NRM Response",
            "Surety Bond",
            "Temporary Need Statement",
            "Agent Agreement",
            "Agent MSPA",
            "H-2ALC MSPA Certificate",
            "Emergency Justification Statement",
            "Appendix A",
            "Appendix A - Joint Employer",
            "Other Supporting Documentation",
          ],
          validate: ["required"],
          tooltip: `Enter the document type of the Ad Hoc Document.`,
        },
        {
          machine_name: "document_description",
          widget: "text",
          label: "Document Description",
          validate: ["required"],
          maxLength: 100,
        },
      ],
    },
  ],
};
